import { DeleteModal, CategoryProductDialog } from "../../../shared";
import * as React from "react";
import { Button, Stack } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { CustomTable } from "../../../shared";
import { CustomeDialog } from "../../../shared";
import { sortItems } from "../../../utils";

export const AvailabilityGroupProducts = (prop) => {
  const {
    state,
    handleModals,
    HandleFilterProduct,
    handlePoductSelect,
    handleAssignProducttoAvailabilityGroup,
    DeleteModals,
    handleDeleteProducts,
    setCurentTab,
  } = prop;
  const ActionButtons = ({ id, deleteAction }) => {
    return (
      <div className="action-buttons" onClick={(e) => e.preventDefault()}>
        <img alt="delete" onClick={deleteAction} src="/icons/ic_delete.svg" />
      </div>
    );
  };
  const columns = React.useMemo(
    () => [
      {
        Header: "Product Name",
        accessor: "name",
        sortType: (prev, curr, columnId) => {
          return sortItems(prev, curr, columnId);
        },
      },
      {
        Header: "PLU Code",
        accessor: "plu",
        Cell: ({ row }) => {
          return (
            <Stack direction="row" gap="12px" alignItems="center">
              {row.original.plu}
            </Stack>
          );
        },
        disableGlobalFilter: true,
        disableSortBy: true,
      },

      {
        Header: "Action",
        id: "action",
        accessor: "id",
        align: "right",
        disableGlobalFilter: true,
        disableSortBy: true,
        accessor: (row, index) => {
          return (
            <ActionButtons
              id={row.id}
              deleteAction={() => {
                DeleteModals(true, row.id);
              }}
            />
          );
        },
      },
    ],
    [],
  );
  return (
    <>
      <CustomTable
        columns={columns}
        data={state.productDetails.productList}
        searchBar={true}
        tableTitle="Products"
        rowsSelection={false}
        tableId="availavilityGroup_products"
        headerRightContent={
          <Button
            type="button"
            size="medium"
            variant="text"
            className="delte"
            startIcon={<AddIcon />}
            onClick={() => handleModals(true)}
            sx={{
              minWidth: "40px",
              p: "8px",
              border: "1px solid rgba(21, 96, 212, 0.12)",
            }}
          >
            Add Products
          </Button>
        }
        onRowLink={(e) => {
          return `/products/details/${e.id}`;
        }}
        onRowAction={() => {
          setCurentTab("productDetails", "1");
        }}
      />
      <CustomeDialog
        open={state.productDetails.isOpen}
        handleClose={() => handleModals(false)}
        PaperProps={{
          sx: { width: "423px", height: "535px", p: "16px" },
        }}
        title="Products"
        content={
          <CategoryProductDialog
            Items={state.productDetails.filteredPoducts}
            onSelect={handlePoductSelect}
            selectedItems={state.productDetails.selectedPoducts}
            onSubmit={handleAssignProducttoAvailabilityGroup}
            onSearch={HandleFilterProduct}
            existedProductList={state.productDetails.productList}
            disabled={state.productDetails.isSaveButtonBusy}
          />
        }
      />
      <DeleteModal
        open={state.productDetails.isDelete}
        handleClose={() => DeleteModals(false, null)}
        onConfirm={handleDeleteProducts}
      />
    </>
  );
};
